import {EnvironmentConfig} from"@me8eon/config";

export function Environment() {
    return <div>
        <pre>{JSON.stringify(EnvironmentConfig, null, 2)}</pre>
    </div>;
}